import {Injectable} from '@angular/core';
import {LocalStorage} from '../../library/local-storage';
import {isUndefined} from 'util';
import {AttachOrg} from '../../models/org';


@Injectable()
export class AttachPartyService {
    constructor(private ls: LocalStorage) {

    }

    party: AttachOrg = new AttachOrg();

    public set_party(party: AttachOrg): void {
        this.party = party;
        this.ls.setObject('attach-party', party);
    }

    public get_party(): AttachOrg {
        if (isUndefined(this.party.party_id)) {
            return this.ls.getObject('attach-party');
        }
        return this.party;
    }

}

